import React from 'react';
import { LocationPage } from './useLocationPage';
import './useLocationPage.css';

// ─── Images ───────────────────────────────────────────────────────────────────
// Swap out any of these for Sarasota-specific shots
import heroImg   from '../images/tampa3.webp';
import bgImg     from '../images/image8.webp';
import slideImg1 from '../images/image121.webp';
import slideImg2 from '../images/image117.webp';
import slideImg3 from '../images/image50.webp';

// ─── Config ───────────────────────────────────────────────────────────────────
const lakeMagdaleneConfig = {

  /* ── SEO ────────────────────────────────────────────────────────────────── */
  pageTitle:       'Lake Magdalene Tree Service | Sam\'s Tree Service',
  metaDescription: 'Professional tree trimming and removal in Lake Magdalene, FL. Sam\'s Tree Service handles dangerous trees safely and affordably.',
  canonicalUrl:    'https://samstreeservice.com/tree_service_lake_magdalene',

  /* ── Hero ───────────────────────────────────────────────────────────────── */
  heroHeading: 'Serving Lake Magdalene',
  heroImageUrl: heroImg,
  bgImageUrl:   bgImg,

  /* ── Slide images ───────────────────────────────────────────────────────── */
  slideImage1: slideImg1,
  slideImage2: slideImg2,
  slideImage3: slideImg3,

  /* ── Main text panel ────────────────────────────────────────────────────── */
  sectionHeading: 'Professional Tree Service in Lake Magdalene Specializing In Dangerous Trees',

  paragraphs: [
    `At <strong>Sam's Tree Service</strong>, we serve the lakefront and residential 
     properties of <strong>Lake Magdalene</strong> with expert tree care built for 
     this beautiful North Tampa community. Properties here back up to lakes and 
     natural areas meaning trees grow large, root systems reach deep into 
     water saturated soil, and storm winds have a clear run at canopies with 
     nothing to break them. When those trees become hazards, our team is ready.`,

    `We specialize in <strong>hazardous tree removal and lakefront trimming</strong> 
     large trees with root instability near lakefront properties, storm damaged 
     overhangs near homes and docks, dense canopy growth increasing your 
     hurricane vulnerability, and precision removals that protect your 
     waterfront views and surrounding landscape.`,

    `<strong>Sam's Tree Service</strong> delivers dependable, professional tree care 
     throughout <strong>Lake Magdalene</strong> and the surrounding 
     <strong>North Hillsborough</strong> lakefront communities keeping your 
     property safe and your landscape healthy through every storm season.`,
  ],
  ctaLabel: 'Get a Free Estimate!',

  /* ── Service buttons (optional — defaults to the 4 standard ones) ────────── */
  // serviceButtons: [
  //   { label: 'Tree Trimming', to: '/tree_trimming' },
  //   { label: 'Tree Removal',  to: '/tree_removal'  },
  //   { label: 'Stump Removal', to: '/stump_removal'  },
  //   { label: 'Debris Hauling',to: '/debris_hauling' },
  // ],

  /* ── Google Map ─────────────────────────────────────────────────────────── */
  mapCity: 'Lake Magdalene, FL',
};

// ─── Page ─────────────────────────────────────────────────────────────────────
const Services_LakeMagdalene = () => <LocationPage config={lakeMagdaleneConfig} />;
export default Services_LakeMagdalene;
